import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatCalendar } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { DashboardCoachComponent } from '../dashboard-coach/dashboard-coach.component';
import { TimeFormatPipe } from '../../../core/shared/pipes/time-format.pipe';
import { MentorAvailabilityComponent } from '../mentors/mentor-availability/mentor-availability.component';
import { UsersAssignedTableComponent } from '../mentors/users-assigned-table/users-assigned-table.component';
import { CustomDatePickerComponent } from '../../../core/shared/components/custom-date-picker/custom-date-picker.component';
import { LoaderService } from '../../../core/shared/services/loader.service';

@Component({
  selector: 'app-dashboard-expert',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MatIconModule,
    MatCalendar,
    MatNativeDateModule,
    TimeFormatPipe,
    MentorAvailabilityComponent,
    UsersAssignedTableComponent,
    CustomDatePickerComponent
  ],
  templateUrl: './dashboard-expert.component.html',
  styleUrl: './dashboard-expert.component.scss'
})
export class DashboardExpertComponent extends DashboardCoachComponent {
  constructor(router: Router, loaderService: LoaderService) {
    super(router, loaderService);
  }
}

